import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Mujeres de más de 50 años que sienten que su cuerpo las traiciona con síntomas físicos aterradores.', 'Madres que sufren el "Nido Vacío" o cambios hormonales que han disparado su nivel de alerta.', 'Personas que no quieren depender de ansiolíticos para funcionar en su día a día.', 'Quienes buscan una solución práctica, discreta y rápida que funcione en cualquier lugar.'];
  const notForWho = ['Personas que buscan un diagnóstico médico o tratamiento psiquiátrico (esto es una herramienta de gestión, no medicina).', 'Quienes prefieren soluciones mágicas sin practicar las técnicas de respiración sugeridas.'];
  return <section className="w-full py-24 px-4 bg-white" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch" data-id="element-3">
          {/* For Who Card */}
          <div className="bg-green-50/50 rounded-3xl p-8 md:p-10 border border-green-100 h-full" data-id="element-4">
            <h3 className="font-serif text-2xl font-bold text-green-900 mb-8 flex items-center" data-id="element-5">
              <span className="bg-green-200 text-green-800 p-2 rounded-full mr-4" data-id="element-6">
                <CheckIcon className="w-5 h-5" aria-hidden="true" data-id="element-7" />
              </span>
              Para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-8">
              {forWho.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-9">
                  <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-10" />
                  <span className="text-green-900/80 text-lg leading-relaxed" data-id="element-11">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Not For Who Card */}
          <div className="bg-brand-cream rounded-3xl p-8 md:p-10 border border-brand-creamDark h-full" data-id="element-12">
            <h3 className="font-serif text-2xl font-bold text-brand-slate mb-8 flex items-center" data-id="element-13">
              <span className="bg-brand-creamDark text-brand-navy p-2 rounded-full mr-4" data-id="element-14">
                <XIcon className="w-5 h-5" aria-hidden="true" data-id="element-15" />
              </span>
              No es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-16">
              {notForWho.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-17">
                  <XIcon className="w-5 h-5 text-brand-slate/50 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-18" />
                  <span className="text-brand-navy text-lg leading-relaxed" data-id="element-19">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}